/**
 * @file   src\messages\validationMessages.ts
 * @brief  This file is responsible for define validation messages.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

export const CommonMessages = {
    email_invalid: "Enter a valid Email Address.",
    email_required: "Enter Email Address.",
    timezone_required: "Select timezone.",
    password_required: "Enter Password.",
    otp_required: 'Enter Verification Code.',
    location_required: "Select Location.",
    subscription_required: "Select Subscription Type.",
    washname_required: "Enter Wash Name.",
    washdetails_required: "Enter Wash Details.",
    washnumber_required: "Enter Number of Washes.",
    maxwashnumber_required: "Enter Maximum Number of Washes per day.",
    amount_required: "Enter Amount.",
    // TEMP: Pre-Auth Amount - may need in future
    // preAuthAmount_required: "Enter Pre-Auth Amount.",
    password_minimum: "Password must be at least 8 characters.",
    password_match: "Passwords must match.",
    address_required: "Enter Address.",
    city_required: "Enter City.",
    country_required: "Select Country.",
    state_required: "Select State.",
    zipcode_required: "Enter ZIP / postal code.",
    zipcode_mismatch: "Enter a valid ZIP / postal code.",
    name_required: "Enter Name.",
    phone_required: "Enter Phone Number.",
    location_name_required: "Enter Location Name.",
    fleet_discount_required: "Enter Discount %.",
    fleet_discount_invalid: "Enter a discount between 0 and 100.",
    fleet_payment_mode_required: "Select Payment Method.",
    equipmentnumber_required: "Enter Bay Number.",
    paystationbrand_required: "Enter Brand.",
    internetconnectivity_required: "Select Internet Connectivity Type.",
    equipmenttype_required: "Select Bay Type.",
    deviceID_required: "Enter Device ID.",
    paymentType_required: "Select Payment Type.",
    accountname_required: "Enter Account Name.",
    accountnumber_required: "Enter Account Number.",
    accountnumber_mismatch: "Account number must be between 6 and 17 digits.",
    accountnumber_fullrequired: "Please enter the full account number",
    routingnumber_required: "Enter Routing Number.",
    routingnumber_mismatch: "Routing number must be exactly 9 digits.",
    accountnumber_match: "Account Numbers must match.",
    oldpassword_required: "Enter old Password.",
    relaynumber_required: "Relay number is required.",
    lpr_usage_type_required: "Select LPR usage type.",
    category_required: "Select Category.",
    camera_name_required: "Enter Camera Name.",
    cardnumber_required: 'Enter Card Number.',
    cardnumber_invalid: 'Enter a valid Card Number.',
    cardexpiry_required: 'Enter Expiry Date.',
    cardexpiry_invalid: 'Enter a valid Expiry Date.',
    cvv_required: 'Enter CVV.',
    cvv_invalid: 'Enter a valid CVV.',
    cardname_required: 'Enter Name on Card.',
    promotionname_required: 'Enter Promotion Name.',
    promocode_required: 'Enter Promo Code.',
    promotiondetails_required: 'Enter Promotion Details.',
    discounttype_required: "Select Discount Type.",
    validFrom_required: 'Enter Start Date.',
    validTo_required: 'Enter End Date.',
    campaignValidFrom_required: 'Enter Valid From.',
    campaignValidTo_required: 'Enter Valid To.',
    subject_required: 'Subject is required.',
    message_required: 'Message is required.',
    advertisementtype_required: 'Advertisement Type is required.',
    advertisementname_required: 'Advertisement Name is required.',
    startDate_required: 'Start Date is required.',
    endDate_required: 'End Date is required.',
    file_required: 'File is required.',
    advertisement_des_required: 'Advertisement Description is required.',
    bonusamount_required: 'Referral Bonus is required.',
    referralbonuslimit_required: 'Referral Bonus Limit is required.',
    description_required: 'Description is required.',
    referralbenefit_required: 'Referral Benefit is required.',
    referralbenefitamount_required: 'Amount is required.',
    subscription_name_required: 'Enter Subscription Name.',
    commission_slab_required: 'Commission Slab is required.',
    commission_type_required: 'Select Commision Type.',
    not_less_than: 'To value should not be less than From value.',
    wash_per_day_exceed: 'Maximum number of washes per day should not exceed total number of washes.',
    percentage_limit: 'Charge cannot be 100 or more if % is selected.',
    charge_required: 'Enter Charge.',
    firstname_required: "Enter First Name.",
    lastname_required: "Enter Last Name.",
    package_name_required: "Enter Package Name.",
    package_description_required: "Enter Package Description.",
    package_price_required: "Enter Package Price.",
    item_name_required: "Enter Item Name.",
    item_description_required: "Enter Item Description.",
    item_price_required: "Enter Item Price.",
    atleast_one_capital_letter: "Include at least one capital letter in the password.",
    atleast_one_small_letter: "Include at least one lowercase letter in the password.",
    atleast_one_special_character: "Include at least one special character in the password.",
    should_not_contain_space: "Password should not contain space",
    stripeSecretKey_required: 'Enter Stripe Secret Key.',
    stripePublicKey_required: 'Enter Stripe Public Key.',
    accountholder_required: "Select account holder type.",
    custom_logo_image_size_validation: "The image file size must not exceed 2 MB.",
    custom_advertisement_image_size_validation: "The image file size must not exceed 2 MB.",
    promoDuration_required: "Select promotion duration.",
    discount_value_required: "Enter Value.",
    start_time_invalid: "Start time must be earlier than end time.",
    end_time_invalid: "End time must not be earlier than start time.",
    start_time_required: "Start Time is required",
    end_time_required: "End Time is required",
    subscription_type_required: "Select subscription type",
    user_suscription_required: "Select target user subscription",
    campaignDuration_required: "Enter campaign duration",
    campaignname_required: "Enter campaign name",
    campaigncode_required: "Eneter campaign code",
    campaigndetails_required: "Enter campaign details",
    permission_required: "Select permission",
    promotion_duration_note: "Select the number of months the promo code should be applied to the user's billing after they successfully apply it for a purchase.",
    campaign_duration_note: "Select the number of months the campaign code should be applied to the user's billing after they successfully apply it for a purchase.",
    select_deviceID_required: "Select Device.",
    device_replace_note: "When replacing a device, the existing device will automatically be removed from the associated bay. The new device must then be assigned to the bay by the Car Wash Owner.",
    washtime_required:"Enter Wash Time",
    priceForExtraTime_required:"Enter Price for Extra Time",
    valid_washtime:"Enter a valid Wash Time",
    baynumber_or_bayname_required:"Enter either Bay Number or Bay Name to continue.",
    secperpulse_required: "Enter seconds per pulse",
    minpulsestostart_required: "Enter minimum pulse to start"
}; 
